<template>
  <div class="clientInfomationWrap">
    <h4 class="subTitle">의뢰인 정보</h4>

    <div class="clientInformationFormWrap">
      <form class="clientInformationForm">

        <div class="clientName"> <!-- 성함 -->
          <div class="labelWrap">
            <strong>성함</strong><br/><span></span>
          </div>

          <div class="inputWrap">
            <input type="text" v-model="information.name" />
          </div>
        </div>

        <div class="clientBusinessType"> <!-- 업태 및 업종 -->

          <div class="labelWrap">
            <strong>업태 및 업종</strong><br/><span>(기업에서 신청할경우)</span>
          </div>
          <div class="inputWrap">
            <input type="text" v-model="information.businessConditions" />
          </div>
        </div>

        <div class="clientBusinessTitle"> <!-- 직위 -->
          <div class="labelWrap">
            <strong>직위</strong><br/><span>(기업에서 신청할경우)</span>
          </div>

          <div class="inputWrap">
            <input type="text" v-model="information.position"  />
          </div>
        </div>

        <div class="clientPhoneNumber"> <!-- 휴대전화번호 -->
          <div class="labelWrap">
            <strong>휴대전화번호</strong><br/><span></span>
          </div>

          <div class="inputWrap">
            <input type="text" v-model="information.phoneNumber" />
          </div>
        </div>

        <div class="clientEmail"> <!-- 이메일 -->
          <div class="labelWrap">
            <strong>이메일</strong><br/><span></span>
          </div>

          <div class="inputWrap">
            <input type="text" v-model="information.email" />
          </div>
        </div>

        <div class="clientAttachment"> <!-- 첨부파일 -->
          <div class="labelWrap">
            <strong>첨부파일</strong><br/><span></span>
          </div>
          <div class="inputWrap">
            <div class="attachment"
                 ref="attachment"
                 @dragover="handleFileDragOver"
                 @dragenter="handleFileDragEnter"
                 @dragleave="handleFileDragLeave"
                 @drop="handleFileDrop"
            >
              <div class="attachmentInitWrap" v-if="attachments.length === 0">
                <div class="attachmentIcon"></div>
                <div class="ment">첨부하실 파일을 이곳에 끌어다 놓으세요.</div>
              </div>
              <div class="attachmentFileList"
                   v-else
              >
                <div class="attachmentFileWrap"
                     v-for="( attachment , index ) in attachments"
                >
                  <div class="attachmentFile">
                    <div class="removeFile"
                         @click="attachmentRemove(index)"
                    >X</div>
                    <span class="fileName" :title="attachment.name">
                      {{attachment.name}}
                    </span>
                  </div>
                </div>
              </div>

            </div>
            <input type="file"
                   multiple
                   style="display: none;"
                   ref="orgFileInput"
                   v-on:change="fileSelection()"
            >
            <button type="button"
                    class="attachmentAddButton"
                    @click="attachmentAdd"
            >
              +
            </button>
          </div>
        </div>

      </form>
    </div>

  </div>
</template>

<script>
  import { mapGetters , mapState , mapActions , mapMutations } from 'vuex'

  export default {
    name: "client-infomation",
    components: {},
    props: [],
    data() {
      return {}
    },
    computed: {
      ...mapState('contactUsStore' , ['attachments' , 'information']) ,
    },
    watch: {
      attachments () {

      },
    },
    methods: {
      ...mapMutations('contactUsStore' , [
        'SET__ATTACHMENT' ,
        'REMOVE__ATTACHEMENT' ,
        'SET__INFORMATION'
      ]) ,
      fileSelection(){

        const {files} = this.$refs['orgFileInput'];
        //console.log(files);
        if( (this.attachments.length + files.length) > 10){
          this.$notie.alert(1 , '파일은 최대 10까지 첨부 할 수 있습니다.' , 3);
        }
        else{
          if(files){
            const maxSize = 5 * 1024 * 1024;
            const overSizeFiles = [];

            for(let i = 0 ; i < files.length ; i++){
              if(files[i].size > maxSize){
                overSizeFiles.push(files[i].name)
              }
              else{
                this.SET__ATTACHMENT(files[i]);
              }
            }

            if(overSizeFiles.length > 0){
              this.$notie.alert(1 , '파일당 최대 첨부 용량은 5MB입니다. <br/>' + '첨부 제외 파일 ('+overSizeFiles.join(",")+')' , 3);
            }
          }
        }

      } ,
      attachmentAdd() {
        this.$refs['orgFileInput'].click();
      },
      attachmentRemove(i) {
        this.REMOVE__ATTACHEMENT(i);
      },
      handleFileDragOver(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      },
      handleFileDragEnter(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      },
      handleFileDragLeave(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      },
      handleFileDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        const dt = ev.dataTransfer;
        const files = dt.files;

        if( (this.attachments.length + files.length) > 10){
          this.$notie.alert(1 , '파일은 최대 10까지 첨부 할 수 있습니다.' , 3);
        }
        else{

          if(files){
            const maxSize = 5 * 1024 * 1024;
            const overSizeFiles = [];
            for(let i = 0 ; i < files.length ; i++){
              if(files[i].size > maxSize){
                overSizeFiles.push(files[i].name)
              }
              else{
                this.SET__ATTACHMENT(files[i]);
              }
            }

            if(overSizeFiles.length > 0){
              this.$notie.alert(1 , '파일당 최대 첨부 용량은 5MB입니다. <br/>' + '첨부 제외 파일 ('+overSizeFiles.join(",")+')' , 3);
            }
          }
        }
      },
      updateInput (t , e) {
        if(this.$store.state['contactUsStore'].information[t] !== e.target.value){
          this.SET__INFORMATION({key : t , value : e.target.value});
        }

      }

    },
    created() {

    },
    updated() {

    },
    mounted() {

    },


  }
</script>

<style scoped lang="scss">
  @import "@/styles/ContactUs.scss";
  .clientInfomationWrap{
    width:55%;
    .clientInformationFormWrap{
      .clientInformationForm{
        display: flex;
        flex-direction: column;
        >div {
          display: flex;
          flex-direction: row;
          margin-bottom:1rem;
          .labelWrap{
            width:20%;
            >strong {
              font-size:1rem;
            }
            >span {
              font-size:0.7rem;
            }
          }
          .inputWrap{
            width:80%;
            >input[type=text] {
              width:90%;
              padding: 0;
              margin: 0;
              border: 0;
              box-shadow: inset 0px -1px 2px #cccccc;
              height:45px;
              font-size:1rem;
              &:focus{
              }
            }
            .attachment{
              width:90%;
              min-height: 100px;
              height:auto;
              background:#fff;
              box-sizing: border-box;
              border:1px solid #cccccc;
              box-shadow: inset 0px -1px 2px #cccccc;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              magin-bottom:0;
              cursor: move;
              cursor: grab;
              cursor: -moz-grab;
              cursor: -webkit-grab;
              .attachmentInitWrap{
                display: flex;
                justify-content: center;
                align-items: center;
                flex-flow: column wrap;

                .attachmentIcon{
                  width:28px;
                  height:34px;
                  background: url(https://s3.ap-northeast-2.amazonaws.com/sf-sunnyfactory/images/icons/attachment.png);
                }
                .ment{
                  color:#999999;
                }
              }
              .attachmentFileList{
                width: 100%;
                height: 100%;
                display: flex;
                flex-flow: row wrap;
                .attachmentFileWrap{
                  width:calc(100%/5);
                  height:50px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  box-sizing: border-box;


                  .attachmentFile {
                    width:80%;
                    height:80%;
                    box-sizing: border-box;
                    border:1px solid #999;
                    font-size:0.8rem;
                    background-color:#292929;
                    color:#fff;
                    border-radius:5px 0 5px 5px ;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    .removeFile{
                      position:absolute;
                      top:0;
                      left:0;
                      width:15px;
                      height:15px;
                      color:#000;
                      background-color:#fff;
                      border:1px solid #000;
                      border-radius: 5px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      cursor:pointer;
                      &:hover {
                        background-color:#666;
                        color:#fff;
                      }

                    }
                    .fileName{
                      display: block;
                      width:100%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      //max-height:40px;
                    }
                  }
                }
              }

            }
            .attachmentAddButton{
              background-color: #cccccc;
              width:90%;
              margin:0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size:1.8rem;
              color:#fff;
              cursor: pointer;
              &:focus {
                outline: 0;
              }
              &:active {
                outline: 0;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/ClientInfomation.vue